import axios from 'axios';
import { API_URL_CTRACKER } from '@shared/api/config';

const APIClientCTracker = axios.create({
  baseURL: `${API_URL_CTRACKER}/api`,
  headers: {
    Accept: 'application/json',
  },
  timeout: 120000,
});

APIClientCTracker.interceptors.request.use((config) => {
  return config;
});

APIClientCTracker.interceptors.response.use(
  (response) => response,
  (error) => {
    // When there is user management logout the user in this point.

    console.log(error);

    throw error;
  },
);

export default APIClientCTracker;
